var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6673 8.60004V11.4C10.6673 13.7334 9.73398 14.6667 7.40065 14.6667H4.60065C2.26732 14.6667 1.33398 13.7334 1.33398 11.4V8.60004C1.33398 6.26671 2.26732 5.33337 4.60065 5.33337H7.40065C9.73398 5.33337 10.6673 6.26671 10.6673 8.60004Z",
    stroke: "#7A2E0E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6673 4.60004V7.40004C14.6673 9.73337 13.734 10.6667 11.4007 10.6667H10.6673V8.60004C10.6673 6.26671 9.73398 5.33337 7.40065 5.33337H5.33398V4.60004C5.33398 2.26671 6.26732 1.33337 8.60065 1.33337H11.4007C13.734 1.33337 14.6673 2.26671 14.6673 4.60004Z",
    stroke: "#7A2E0E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy2);
export default __webpack_public_path__ + "static/media/copy2.62c933d9e146c633c2ba3e61a60ad729.svg";
export { ForwardRef as ReactComponent };